var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteArrowRoundR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 47,
  height: 47,
  rx: 23.5,
  stroke: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 32L32 16M32 16V32M32 16H16",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteArrowRoundR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white-arrow-round-r.2567dca502ccc3e78e0373342c3b996e.svg";